// Define and export FormType constants
// These constants help manage which form should be displayed at any time.
export const FormType = {
  CampaignAdModal: "campaignAdModal",
  CategoryNameFormatSearch: "categoryNameFormatSearch",
  RelationalCategoryMenuPopup: "relationalCategoryMenuPopup",
  CampaignAmount: "campaignAmount",
  Checkout: "checkout",
};
